/**
 * NeedCustomFieldService
 * Service for managing need-level custom-field definitions (the extra intake fields a CareNeed
 * declares for the public help-request form). Mirrors ACCourses' CourseCustomFieldService.
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for need custom-field definition CRUD operations. Read views are enriched with the
 * resolved shared CustomFieldType (name/color/icon/data-kind).
 */
export class NeedCustomFieldService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? NeedCustomFieldService.DEFAULT_SERVICE_PATH,
            basePath: NeedCustomFieldService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Get all custom-field definitions for a need (enriched views). */
    async byNeed(needId) {
        const response = await this.byNeedRaw(needId);
        return response.data ?? [];
    }
    byNeedRaw(needId) {
        return this.http.get(this.buildUrl(`by-need/${needId}`));
    }
    /** Get a single custom-field definition (enriched view). */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data)
            throw new Error(`Need custom field ${id} not found`);
        return response.data;
    }
    getViewRaw(id) {
        return this.http.get(this.buildUrl(`${id}`));
    }
}
NeedCustomFieldService.DEFAULT_SERVICE_PATH = 'ac-counselling';
NeedCustomFieldService.BASE_PATH = 'api/need-custom-fields';
//# sourceMappingURL=NeedCustomFieldService.js.map